import React from "react";
import styles from "../InverluxApps.module.css";

const TinyJpgPngStoreButton = () => (
  <a
    className={styles.storeButton}
    href="https://chromewebstore.google.com/detail/tiny-jpg-png/goeibhbekbljogioaoopemefgdgpfpal"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Add Tiny JPG & PNG to Chrome"
  >
    <span className={styles.storeButtonIcon} aria-hidden="true">↗</span>
    <span>
      <span className={styles.storeButtonLabel}>Add to Chrome</span>
      <span className={styles.storeButtonStatus}>Chrome Web Store</span>
    </span>
  </a>
);

export default TinyJpgPngStoreButton;
